import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/testimonials`);
        setTestimonials(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
        setError('Failed to load testimonials');
        setLoading(false);
        // No fallback data - if API fails, show empty state
        setTestimonials([]);
      }
    };

    fetchTestimonials();
  }, []);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        size={16}
        className={index < rating ? 'fill-current' : 'stroke-current'}
        style={{ color: 'var(--brand-primary)' }}
      />
    ));
  };

  if (loading) {
    return (
      <section id="testimonials" className="section" style={{ backgroundColor: 'var(--bg-page)' }}>
        <div className="container">
          <div className="text-center">
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Loading testimonials...
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="testimonials" className="section" style={{ backgroundColor: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6">Client Success Stories</h2>
          <p className="body-medium max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            Discover how we've helped small businesses transform their digital presence and achieve measurable growth.
          </p>
        </div>
        
        {testimonials.length === 0 ? (
          <div className="text-center py-12">
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We're building our portfolio of client success stories. 
              <br />
              Contact us to be one of our featured clients!
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="flex items-center gap-2 mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                
                <p className="body-small mb-6" style={{ color: 'var(--text-secondary)' }}>
                  "{testimonial.text}"
                </p>
                
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center text-sm font-semibold"
                    style={{ 
                      backgroundColor: 'var(--brand-primary)', 
                      color: 'var(--text-inverse)' 
                    }}
                  >
                    {testimonial.avatar}
                  </div>
                  
                  <div>
                    <h4 className="heading-6">{testimonial.name}</h4>
                    <p className="caption" style={{ color: 'var(--text-secondary)' }}>
                      {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default TestimonialsSection;